var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.inputWrapperConfigs.visible) ? _c('span', {
    on: {
      "keyup": function($event) {
        _vm.validateOnValueChange ? null : _vm.checkInputValue(false)
      }
    }
  }, [_c('div', {
    staticClass: "wrapper-input",
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": _vm.input_id
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.showInvalidEnvironment && _vm.invalid) ? _c('popover-alert', {
    attrs: {
      "effect": "fade",
      "placement": "right",
      "content": _vm.invalidMessage,
      "popoverCondition": _vm.toggleInvalidMessage,
      "showOK": false,
      "showNO": false,
      "popoverStyle": {
        left: '50px',
        'max-width': '200px',
        width: '200px',
        'font-size': 'small',
        height: 'max-content',
        'background-color': '#f2dede',
        'border-color': '#ebccd1'
      },
      "arrowStyle": {
        top: '50%'
      },
      "textStyle": {
        color: '#a94442'
      },
      "classes": "errorArrow"
    }
  }, [_c('a', {
    staticStyle: {
      "position": "absolute",
      "top": "3px",
      "right": "5px",
      "cursor": "pointer"
    },
    style: (_vm.aIconStyle),
    attrs: {
      "id": _vm.toggle_id
    },
    on: {
      "click": _vm.toggleInvalid
    }
  }, [_c('i', {
    class: _vm.$root.icons.exclamation,
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "aria-hidden": "true"
    }
  })])]) : _vm._e()], 2)]) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a2fd540","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dynamic/inputWrapper/inputWrapper.vue
// module id = 1417
// module chunks = 1